module.exports = __webpack_public_path__ + "static/media/inktoberAcorns.25bd02e3.gif";